// extracted by mini-css-extract-plugin
module.exports = {"PriceBox":"Prices_PriceBox__2lwfr","Price":"Prices_Price__3qtYo","OldPrice":"Prices_OldPrice__2z06k","NewPrice":"Prices_NewPrice__2buN-"};